import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ServicesGrid } from "@/components/ServicesGrid";
import { CitiesStrip, CitiesSection } from "@/components/Cities";
import { About } from "@/components/About";
import { LeadForm } from "@/components/LeadForm";
import { FAQSection } from "@/components/FAQSection";
import { Testimonials } from "@/components/Testimonials";
import { MapSection, Footer, FloatWhatsApp } from "@/components/Footer";

function App() {
  return (
    <div data-testid="homepage">
      <Header />
      <Hero />
      <CitiesStrip />
      <ServicesGrid />
      <CitiesSection />
      <About />
      <LeadForm />
      <Testimonials />
      <FAQSection />
      <MapSection />
      <Footer />
      <FloatWhatsApp />
    </div>
  );
}

export default App;
